<template>
    <div class="payment_innercont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="payment_headerimg" style="display:none;"></div>


        <div class="payment_form" v-show="innerformid==20">
            <div class="innerform_title">AZONOSÍTÁS</div>

            <div class="payment_form_content">
                <div class="btnAuthSelect" @click="NavToForm(30)">
                    <i class="fas fa-user-circle" style="font-size:30px;"></i>
                    <br><br>
                    Portál bejelentkezéssel
                </div>

                <div class="btnAuthSelect" @click="NavToForm(40)">
                    <i class="fas fa-credit-card" style="font-size:30px;"></i>
                    <br><br>
                    Egészségkártyával
                </div>

            </div>
        </div>

        <div class="payment_form" v-show="innerformid==30">
            <div class="innerform_title">PORTÁL BEJELENTKEZÉS</div>

            <div class="payment_form_content">
                <GrcText ref="txtEmailCim" grc_labeltext="E-mail cím:" grc_placeholder="..."
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                style="margin-bottom:20px; margin-top:10px;"
                />

                <GrcText ref="txtJelszo" grc_labeltext="Jelszó:" grc_placeholder="..."
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('btnPortalAuth_Login');"
                grc_ispassword="true"
                style="margin-bottom:20px;"
                />

                <div class="btncont">

                    <GrcButton ref="btnPortalAuth_Login" grc_text="Bejelentkezés" @grc-click="btnPortalAuth_Login_click" grc_readonly="false" 
                    grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="130px"
                    grc_buttonpos="left"
                    grc_textalign="center"
                    grc_lefticon="<i class='fas fa-check'></i>"
                    style="display:inline-block;" />                    

                    <GrcButton ref="btnPortalAuth_Megsem" grc_text="Mégsem" @grc-click="NavToForm(20)" grc_readonly="false" 
                    grc_color="grey" grc_shadow="false" grc_radius="2px" grc_width="130px"
                    grc_buttonpos="left"
                    grc_textalign="center"
                    grc_lefticon="<i class='fas fa-times'></i>"
                    style="display:inline-block; margin-left:20px; margin-right:0px;" />        
                </div>
            </div>

        </div>


        <div class="payment_form" v-show="innerformid==40">
            <div class="innerform_title">EGÉSZSÉGKÁRTYA</div>

            <div class="payment_form_content">

                <GrcKartyaszam2 ref="txtKartyaszam" v-model="epkartyaszam"
                grc_labeltext="Kártyaszám:" grc_labelmode="above" grc_labelwidth="200px"
                v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiIdo');"
                style="margin-bottom:20px; margin-top:10px;"
                />

                <GrcDate ref="txtSzuletesiIdo" v-model="txtSzuletesiIdo" grc_dateformat="ymd" grc_sep="." 
                grc_labeltext="Születési idő:" grc_labelmode="above" grc_labelwidth="200px" grc_readonly="false"
                v-on:grc-keydown-enter="SetControlToFocus('btnAuth_Login');"
                v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo')"
                v-on:dropdownclosed="SetPopupRef('')"
                style="margin-bottom:20px;"
                />


                <div class="btncont">

                    <GrcButton ref="btnAuth_Login" grc_text="Rendben" @grc-click="btnAuth_Login_click" grc_readonly="false" 
                    grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="130px"
                    grc_buttonpos="left"
                    grc_textalign="center"
                    grc_lefticon="<i class='fas fa-check'></i>"
                    style="display:inline-block;" />                    

                    <GrcButton ref="btnAuth_Megsem" grc_text="Mégsem" @grc-click="NavToForm(20)" grc_readonly="false" 
                    grc_color="grey" grc_shadow="false" grc_radius="2px" grc_width="130px"
                    grc_buttonpos="left"
                    grc_textalign="center"
                    grc_lefticon="<i class='fas fa-times'></i>"
                    style="display:inline-block; margin-left:20px; margin-right:0px;" />        
                </div>
            </div>

        </div>


        <div class="payment_form" v-show="innerformid==100">
            <div class="innerform_title">FIZETÉS</div>

            <div class="payment_form_content">

                <div class="fiz_tagnev"><i class="fas fa-user-circle" style="margin-right:10px;"></i>{{Tagkod}} - {{TagNev}}</div>

                <div class="fiz_osszeg_label">Fizetendő:</div>
                <div class="fiz_osszeg">{{Fizetendo}}</div>

                <div class="fiz_egyenleg_label" v-show="MinBankkartyaOsszeg>0">Aktuális egyenleg:</div>
                <div class="fiz_egyenleg" v-show="MinBankkartyaOsszeg>0">{{Egyenleg}}</div>

                <div class="fizetes_button_spacer">&nbsp;</div>
                
                <div class="btnAuthSelect" @click="RendelesKifizetes" v-show="MinBankkartyaOsszeg==0">
                    <i class="fas fa-check" style="margin-right:10px;"></i>Fizetés
                </div>

                <div class="egyenlegfeltoltes_warning" v-show="MinBankkartyaOsszeg>0">Nincs megfelelő fedezet a számládon, kérjük, töltsd fel egyenleged a bankkártyáddal.</div>

                <div class="btnAuthSelect btnBlue" @click="NavToForm(110)" v-show="MinBankkartyaOsszeg>0">
                    <i class="far fa-credit-card" style="margin-right:10px;"></i>Egyenleg feltöltés
                </div>


                <div class="btnAuthSelect btnGrey" style="display:none;">
                    <i class="fas fa-chevron-left" style="margin-right:10px;"></i>Másik fiók választása
                </div>
            </div>
        </div>

        <div class="payment_form" v-show="innerformid==110">
            <div class="innerform_title">BANKKÁRTYÁS BEFIZETÉS</div>

            <div class="payment_form_content">

                <div class="fiz_tagnev"><i class="fas fa-user-circle" style="margin-right:10px;"></i>{{Tagkod}} - {{TagNev}}</div>

                <GrcCombo ref="cboToken" v-model="tokenid" grc_labeltext="Bankkártya:"
                grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                grc_keyfield="id" grc_displayfield="Megnevezes"
                v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}, {fieldname:'CardMask', width:'100px', cutlongtext:'true'}]"
                v-on:grc-keydown-enter="SetControlToFocus('txtBK_Osszeg');"
                v-on:dropdownopened="SetPopupRef('cboToken')"
                v-on:dropdownclosed="SetPopupRef('')"
                style="margin-bottom:20px; margin-top:10px;"
                />

                <GrcNum ref="txtBK_Osszeg" v-model="txtBK_Osszeg" 
                grc_labeltext="Összeg:" grc_labelmode="above" grc_labelwidth="80px"
                grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                v-on:grc-keydown-enter="SetControlToFocus('txtBK_EmailCim');"
                style="margin-bottom:10px;"
                />

                <div class="txtBK_Osszeg_info" style="margin-bottom:20px;">
                    Az összeg a fizetendő összeg kiegyenlítéséhez szükséges összeg, azaz fizetendő összeg megnövelve a pénztár működési költségével.
                </div>

            
                <GrcText ref="txtBK_EmailCim" grc_labeltext="Értesítési e-mail cím:" grc_placeholder="..."
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('btnBK_Befizetes');"
                style="margin-bottom:20px;"
                />

                <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkFelhFelt" /></td>
                    <td valign="top" style="text-align:left; font-family:'PremiumDefault'; font-size:14px; line-height:18px; color:var(--premblue);" v-html="feltetel">
                    </td>
                </tr>
                </table>           

                <div style="width:100%; box-sizing:border-box; text-align:center; margin-bottom:20px;">
                    <img src="../../../public/styles/images/simplepay_w360.png" style="width:100%;" />
                </div>



                <div class="btncont">

                    <GrcButton ref="btnBK_Tovabb" grc_text="Tovább" @grc-click="btnBK_Befizetes_click" grc_readonly="false" 
                    grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="130px"
                    grc_buttonpos="left"
                    grc_textalign="center"
                    grc_lefticon="<i class='fas fa-chevron-right'></i>"
                    style="display:inline-block;" />                    

                    <GrcButton ref="btnBK_Megsem" grc_text="Mégsem" @grc-click="NavToForm(100)" grc_readonly="false" 
                    grc_color="grey" grc_shadow="false" grc_radius="2px" grc_width="130px"
                    grc_buttonpos="left"
                    grc_textalign="center"
                    grc_lefticon="<i class='fas fa-times'></i>"
                    style="display:inline-block; margin-left:20px; margin-right:0px;" />        
                </div>


            </div>
        </div>

        <div class="payment_form" v-show="innerformid==115">
            <div class="innerform_title">CSODAKÁRTYA BEÁLLÍTÁS</div>

            <div class="payment_form_content">

                <div class="fiz_tagnev"><i class="fas fa-user-circle" style="margin-right:10px;"></i>{{Tagkod}} - {{TagNev}}</div>

                <div class="csodakartya_text1" style="margin-top:20px;" v-html="csodakartya_text1"></div>

                <table style="width:100%; margin-top:10px; margin-bottom:30px;" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkCsodaFelt" /></td>
                    <td valign="top" style="text-align:justify; font-family:'PremiumDefault'; font-size:14px; line-height:18px; color:var(--premblue);">
                        Beállítom a csodakártya szolgáltatást az egészségkártyás vásárláshoz és elfogadom a
                        <span style="text-decoration:underline; cursor:pointer;" @click="ShowCsodaFelt">feltételeket</span>.
                    </td>
                </tr>
                </table>            

                <div class="btncont">

                    <GrcButton ref="btnBK_Befizetes" grc_text="Befizetés" grc_readonly="false" 
                    grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="130px"
                    grc_buttonpos="left"
                    grc_textalign="center"
                    grc_lefticon="<i class='fas fa-check'></i>"
                    style="display:inline-block;" />                    

                </div>


            </div>
        </div>


        <div class="payment_form" v-show="innerformid==120">
            <div class="innerform_title">SIKERES FIZETÉS</div>
            <div class="payment_form_content">

                <div class="fiz_osszeg_label">fizetve:</div>
                <div class="fiz_osszeg">{{fizetes_result_osszeg}}</div>
                <div class="fiz_authid">engedélyszám: {{fizetes_result_authid}}</div>

                <div class="spinner_cont" style="margin-top:20px;">
                    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                </div>
                <div class="payment_result_redir_text" style="margin-bottom:20px;">A rendelés lezárásához átirányítunk a webáruházba</div>


                <div class="btnAuthSelect btnGrey" @click="BackToShop">
                    <i class="fas fa-chevron-left" style="margin-right:10px;"></i>Vissza a webáruházba
                </div>

            </div>
        </div>

        <div class="payment_form" v-show="innerformid==130">
            <div class="innerform_title">FIZETÉS MEGSZAKÍTVA</div>
            <div class="payment_form_content">

                <div class="spinner_cont" style="margin-top:20px;">
                    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                </div>
                <div class="payment_result_redir_text" style="margin-bottom:20px;">A rendelés lezárásához átirányítunk a webáruházba</div>

                <div class="btnAuthSelect btnGrey" @click="BackToShop">
                    <i class="fas fa-chevron-left" style="margin-right:10px;"></i>Vissza a webáruházba
                </div>

            </div>
        </div>

        <div class="payment_cancel" v-show="CanBeCancelled">
            <span class="payment_cancel_button" @click="CancelPayment"><i class="fas fa-times" style="margin-right:6px;"></i>fizetés megszakítása</span>
        </div>

    </div>
</template>

<script>

import Vue from 'vue'
import { setTimeout } from 'timers';

import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcAdoazon from '../GrcComponents/GrcAdoazon.vue'
import GrcKartyaszam2 from '../GrcComponents/GrcKartyaszam2.vue'



export default {
  name: 'frmVPOS_Azonositas',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcCheckboxMobile,
      GrcDate,
      GrcNum,
      GrcAdoazon,
      GrcKartyaszam2,

  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmVPOS",
            gPopupControlName:"",

            epkartyaszam:"",
            txtSzuletesiIdo:"",
            txtEmailCim:"",

            innerformid:0,
            Tagkod:0,
            TagNev:"",
            Egyenleg:"",
            PayHeaderID:0,
            PayRefNum:"",
            Fizetendo:"",
            MinBankkartyaOsszeg:0,

            TOKENLIST:[],
            tokenid:0,
            txtBK_Osszeg:0,

            fizetes_result_osszeg:"",
            fizetes_result_returnurl:"",
            fizetes_result_authid:"",

            CanBeCancelled:true,

            feltetel:"",
            csodakartya_text1:"",
            csoda_feltetel:"",

      }
  },
  model: {
  },  
  methods:{

    ShowCsodaFelt()
    {
      this.ShowInfoDialog(this.csoda_feltetel, "400", "500");
    },

    StartRedirectBackToShop()
    {
        var self = this;
        setTimeout(function(){ document.location = self.fizetes_result_returnurl;  } , 3000);   
    },

    async CancelPayment()
    {
        var DialogResult = "";

        var p = grccomp_dialog_yesno_GetDefaults("Megerősítés", "Biztosan megszakítod a fizetést?");             
        p.height = 200;
        p.width = 300;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }

        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });        

        if (DialogResult != "YES") { return; }

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iPayHeaderID: this.PayHeaderID,
            sPayRefNum: this.PayRefNum,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmVPOS_CancelPayment", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.CanBeCancelled = false;
        this.fizetes_result_returnurl = Q.RESULT[0].ReturnUrl;

        this.innerformid = 130;

        this.StartRedirectBackToShop();
    },
    
    BackToShop()
    {
        document.location = this.fizetes_result_returnurl;
    },

    async RendelesKifizetes()
    {
        //alert("fizetés");
        //return;

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iPayHeaderID: this.PayHeaderID,
            sPayRefNum: this.PayRefNum,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmVPOS_Zarolas", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            return;
        }

        //console.log(Q.PAYMENT);

        this.$refs.GRCDB.HideLoading();
        
        var InfoText = "";

        if (Q.RESULT[0].Sikeres != 1)
        {
            this.MinBankkartyaOsszeg = Q.RESULT[0].MinBankkartyaOsszeg;
            InfoText = Q.RESULT[0].ResultText;
            await this.ShowInfoDialog(InfoText, "200", "400");
            return;
        }

        this.CanBeCancelled = false;
        this.fizetes_result_osszeg = Q.RESULT[0].strOsszeg;
        this.fizetes_result_returnurl = Q.RESULT[0].ReturnUrl;
        this.fizetes_result_authid = Q.RESULT[0].AUTHID;

        this.innerformid = 120;

        this.StartRedirectBackToShop();

    },

    SetTagAdat(pTagkod, pTagNev, pEgyenleg, pEmailCim, pMinBankkartyaOsszeg, pBANKKARTYA)
    {
        this.Tagkod = pTagkod;
        this.TagNev = pTagNev;
        this.Egyenleg = pEgyenleg;
        this.EmailCim = pEmailCim;
        this.MinBankkartyaOsszeg = pMinBankkartyaOsszeg;

        this.TOKENLIST = pBANKKARTYA;
        this.$refs.cboToken.SetDataSource(pBANKKARTYA);
        this.$refs.cboToken.SetValue(0);
    },


    Init(pTAGADAT, pPayHeaderID, pPayRefNum, pFizetendo, pBANKKARTYA)
    {
        this.feltetel = grcmain_GetTextBookItem("frmBefizetes", "feltetel");

        this.csodakartya_text1 = grcmain_GetTextBookItem("frmVPOS", "csodakartya_text1");
        this.csoda_feltetel = grcmain_GetTextBookItem("frmVPOS", "csodakartya_felt");

        this.PayHeaderID = pPayHeaderID;
        this.PayRefNum = pPayRefNum;
        this.Fizetendo = pFizetendo;

        this.SetTagAdat(pTAGADAT[0].Tagkod, pTAGADAT[0].TagNev, pTAGADAT[0].Egyenleg, pTAGADAT[0].EmailCim, pTAGADAT[0].MinBankkartyaOsszeg, pBANKKARTYA);

        if (this.Tagkod > 0) { this.innerformid = 100; }
        else { this.innerformid = 20; }

    },



    btnBK_Befizetes_click()
    {
        if (this.$refs.chkFelhFelt.GetValue() == 0)
        {
            this.ShowInfoDialog("A felhasználási feltételek elfogadása kötelező!", "200", "400");
            return;
        }
        
        if (this.$refs.txtBK_Osszeg.GetValue() < this.MinBankkartyaOsszeg)
        {
            this.ShowInfoDialog("A rendelése kifizetéséhez min. "+this.MinBankkartyaOsszeg+" Ft szükséges!", "200", "400");
            return;
        }

        if (this.$refs.txtBK_EmailCim.GetText() == "")
        {
            this.ShowInfoDialog("Az e-mail cím megadása kötelező!", "200", "400");
            return;
        }

        if (this.$refs.cboToken.GetValue() == 0)
        {
            this.ShowInfoDialog("Kérjük válaszd ki a bankkártyádat!", "200", "400");
            return;
        }

        if (this.$refs.cboToken.GetValue() == -1)
        {
            // nem regisztralt kartyaval
            this.PreparePayment();
        }
        else
        {
            this.StartTokenPayment();
        }
    },

   async StartTokenPayment()
    {

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iTokenID: this.$refs.cboToken.GetValue(),
            iOsszeg: this.$refs.txtBK_Osszeg.GetValue(),
            sEmailCim: this.$refs.txtBK_EmailCim.GetText(),
            sOrderNumPrefix: "EBT",
            iPayHeaderID: this.PayHeaderID,
            sPayRefNum: this.PayRefNum,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmVPOS_StartTokenPayment", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            return;
        }

        //console.log(Q.PAYMENT);

        this.$refs.GRCDB.HideLoading();
        
        var InfoText = "";

        if (Q.PAYMENT[0].intResult != 1)
        {
            InfoText = "Sikertelen fizetés: "+Q.PAYMENT[0].ResultText;
            return;
        }
        else
        {
            InfoText = Q.PAYMENT[0].InfoText;// "Sikeres fizetés!";
        }

        await this.ShowInfoDialog(InfoText, "200", "400");

        this.Egyenleg = Q.PAYMENT[0].Egyenleg;
        this.MinBankkartyaOsszeg = Q.PAYMENT[0].MinBankkartyaOsszeg;

        this.innerformid = 100;
    },





    async PreparePayment()
    {

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iOsszeg: this.$refs.txtBK_Osszeg.GetValue(),
            sEmailCim: this.$refs.txtBK_EmailCim.GetText(),
            sProductName:"Egyéni befizetés",
            sProductCode:"EB",
            sOrderNumPrefix: "EB",
            iPayHeaderID: this.PayHeaderID,
            sPayRefNum: this.PayRefNum,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmVPOS_PreparePayment", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            return;
        }


        //console.log(Q.PAYMENT);

        this.$refs.GRCDB.HideLoading();
        
        if (Q.PAYMENT[0].intResult != 1)
        {
            alert(Q.PAYMENT[0].strResult);
            return;
        }

        //console.log(this.SIMPLE_LIVEUPDATE_URL);

        var SIMPLE_LIVEUPDATE_URL = Q.PAYMENT[0].SIMPLE_LIVEUPDATE_URL;
        var TIMEOUT_URL = Q.PAYMENT[0].PAYCENTER_TIMEOUT;
        var BACK_REF = Q.PAYMENT[0].PAYCENTER_BACKREF;

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = SIMPLE_LIVEUPDATE_URL;
        var myInput;

        myInput = document.createElement("input");
        myInput.setAttribute("name", "MERCHANT");
        myInput.setAttribute("id", "MERCHANT");
        myInput.setAttribute("value", Q.PAYMENT[0].MERCHANT);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_REF");
        myInput.setAttribute("id", "ORDER_REF");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_REF);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_DATE");
        myInput.setAttribute("id", "ORDER_DATE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_DATE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PNAME[]");
        myInput.setAttribute("id", "ORDER_PNAME");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PNAME);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PCODE[]");
        myInput.setAttribute("id", "ORDER_PCODE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PCODE);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PRICE[]");
        myInput.setAttribute("id", "ORDER_PRICE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PRICE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_VAT[]");
        myInput.setAttribute("id", "ORDER_VAT");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_VAT);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_QTY[]");
        myInput.setAttribute("id", "ORDER_QTY");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_QTY);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PRICES_CURRENCY");
        myInput.setAttribute("id", "PRICES_CURRENCY");
        myInput.setAttribute("value", "HUF");
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "TIMEOUT_URL");
        myInput.setAttribute("id", "TIMEOUT_URL");
        myInput.setAttribute("value", TIMEOUT_URL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "BACK_REF");
        myInput.setAttribute("id", "BACK_REF");
        myInput.setAttribute("value", BACK_REF);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "BILL_EMAIL");
        myInput.setAttribute("id", "BILL_EMAIL");
        myInput.setAttribute("value", Q.PAYMENT[0].BILL_EMAIL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_HASH");
        myInput.setAttribute("id", "ORDER_HASH");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_HASH);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PAY_METHOD");
        myInput.setAttribute("id", "PAY_METHOD");
        myInput.setAttribute("value", "CCVISAMC");
        myForm.appendChild(myInput);

        if (Q.PAYMENT[0].LU_ENABLE_TOKEN == "1")
        {
            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_ENABLE_TOKEN");
            myInput.setAttribute("id", "LU_ENABLE_TOKEN");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_ENABLE_TOKEN);
            myForm.appendChild(myInput);

            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_TOKEN_TYPE");
            myInput.setAttribute("id", "LU_TOKEN_TYPE");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_TOKEN_TYPE);
            myForm.appendChild(myInput);
        }


        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        


    },
        





    NavToForm(pIndex)
    {
        if (pIndex == 40)
        {
            this.$refs.txtKartyaszam.SetText("");
            this.$refs.txtSzuletesiIdo.SetText("");
        }

        if (pIndex == 110)
        {
            this.$refs.txtBK_Osszeg.SetValue(this.MinBankkartyaOsszeg);
            this.$refs.txtBK_EmailCim.SetText(this.EmailCim);
            this.$refs.cboToken.SetValue(0);
        }

        this.innerformid = pIndex;
    },

    btnPortalAuth_Login_click()
    {
        this.Auth(3, this.$refs.txtEmailCim.GetText(), this.$refs.txtJelszo.GetText(), "", "");
    },

    btnAuth_Login_click()
    {
        if (this.$refs.txtSzuletesiIdo.IsValid(false) == false)
        {
            this.ShowInfoDialog("A születési idő nincs megadva vagy helytelen!", "200", "400");
            return;
        }

        this.Auth(4, "", "", this.$refs.txtKartyaszam.GetText(), this.$refs.txtSzuletesiIdo.GetText());
    },

    async Auth(pLoginMethodID, pEmailCim, pJelszo, pKartyaszam, pSzuletesiIdo)
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iLoginMethodID: pLoginMethodID,
            iPayHeaderID: this.PayHeaderID,
            sPayRefNum: this.PayRefNum,
            sEmailCim: pEmailCim,
            sJelszo: pJelszo,
            sKartyaszam: pKartyaszam,
            sSzuletesiIdo: pSzuletesiIdo,
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Auth", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.ShowInfoDialog("Az alkalmazás verzió elévült!", "200", "400");
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            }
            return;
        }

        if (Q.FA[0].FA_Engedely < 1)
        {
            this.$refs.GRCDB.HideLoading();
            var DialogResult = "";
            var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), Q.FA[0].FA_ResultText);             
            p.height = Q.FA[0].FA_H;
            p.width = Q.FA[0].FA_W;
            p.padding_top = -1;
            if (grccomp_getScreenSize().width < 400) { p.width = 300; }
            await this.$refs.Dialog.ShowDialog(p).then(res => 
            { 
                DialogResult = res; 
            });               

            return;
        }

        this.SetTagAdat(Q.RESULT[0].Tagkod, Q.RESULT[0].TagNev, Q.RESULT[0].Egyenleg, Q.RESULT[0].EmailCim, Q.RESULT[0].MinBankkartyaOsszeg, Q.BANKKARTYA);

        this.$refs.GRCDB.HideLoading();

        this.NavToForm(100);

    },



    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmVPOS", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = "Fizető app"; // this.GetTextBookItem("title");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
      },


    async ShowInfoDialog(pText, pHeight, pWidth)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = pWidth;
        p.padding_top = -1; //20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {

  }

}


</script>


<style scoped>


.innerform
{
    width:100%;
    box-sizing: border-box;
}


.payment_innercont {
    width: 100%;
    min-height: 263px;
    box-sizing: border-box;
    background-color: #fff;
    display: block;

    border: 1px solid #bbb;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 5px 2px #ccc;
    box-shadow: 0px 0px 5px 2px #ccc;
   
}

.payment_headerimg
{
    width:100%;
    box-sizing: border-box;
    display:block;
    height:75px;
    background-image: url(../../../public/styles/images/vpos/headerimg14.jpg);
    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;    
}


.payment_form
{
    width:100%;
    box-sizing: border-box;
    padding:0px;
}

.payment_form_content
{
    width:100%;
    box-sizing: border-box;
    padding:10px;
    max-width: 400px;
    margin:0px auto;
}

.innerform_title
{
    width:100%;
    box-sizing: border-box;
    font-size:20px;
    line-height: 20px;
    text-align: center;
    font-weight: 500;
    letter-spacing: 1px;    
    padding: 27px 5px 25px 5px;
    background-color: dodgerblue;
    color: #fff;
    -webkit-box-shadow: 0px 3px 5px #aaa;
    box-shadow: 0px 3px 5px #aaa;    
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background-color: var(--premgreen);
}

.btnAuthSelect
{
    width:100%;
    max-width: 250px;
    box-sizing: border-box;
    font-size:13px;
    line-height: 13px;
    color:#fff;
    text-align: center;
    font-weight: 500;
    background-color: var(--premblue);
    padding:20px 10px;
    cursor:pointer;
    border-radius: 5px;
    margin: 10px auto;
    text-transform: uppercase;
    letter-spacing: 1px;
    border: solid 1px var(--premblue);
}

.btnAuthSelect:hover
{
    background-color: var(--premgreen);
    /* box-shadow: 0 0 0 2px rgb(175 200 11 / 50%); */
    border-color: #fff;
}

.btnGrey
{
    background-color: #eaebec;
    color: #444;
    border: solid 1px #ccc;
}

.btnGrey:hover
{
    background-color: #f0f1f2;        
    box-shadow: 0 0 0 2px gainsboro;
    border-color: #ccc;
}

.btnBlue
{
    background-color: var(--premblue);        
    box-shadow: 0 0 0 2px var(--premblue);
    border-color: #fff;
}

.btnBlue:hover
{
    background-color: var(--premgreen);
    box-shadow: 0 0 0 2px var(--premgreen);    
}





.btnYellow
{
    background-color:#fff380;
    color: #444;
    border: solid 1px #ccc;
}

.btnYellow:hover
{
    background-color:#fff380;
    box-shadow: 0 0 0 2px rgb(255 216 1);
    border-color:#fff;
}

.btnGreen
{
    background-color:var(--premgreen);
    color: #fff;
    border: solid 1px #fff;
    font-size: 16px;
    line-height: 16px;
    padding-top: 23px;    
    /* box-shadow: 0 0 0 2px rgb(175 200 11); */
    opacity:1;
}

.btnGreen:hover
{
    opacity: 0.8;
}



.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.fiz_tagnev
{
    width:100%;
    box-sizing: border-box;
    font-size:15px;
    line-height: 18px;
    color:var(--premblue);
    text-align: center;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 10px 0px 0px 0px;
}

.fiz_osszeg
{
    width:100%;
    box-sizing: border-box;
    font-size:40px;
    line-height: 40px;
    color: var(--premgreen);
    text-align: center;
    font-weight: 500;
    letter-spacing: 1px;
    margin: 15px 0px 5px 0px;

}

.fiz_osszeg_label
{
    width:100%;
    box-sizing: border-box;
    font-size:20px;
    line-height: 20px;
    color: #999;
    text-align: center;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 20px 0px 0px 0px;
}


.fiz_egyenleg
{
    width:100%;
    box-sizing: border-box;
    font-size:28px;
    line-height: 28px;
    color: var(--premblue);
    text-align: center;
    font-weight: 500;
    letter-spacing: 1px;
    margin: 15px 0px 5px 0px;

}

.fiz_egyenleg_label
{
    width:100%;
    box-sizing: border-box;
    font-size:20px;
    line-height: 20px;
    color: #999;
    text-align: center;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 30px 0px 0px 0px;
}

.fizetes_button_spacer
{
    width:100%;
    box-sizing: border-box;
    font-size:1px;
    line-height: 1px;
    height:20px;
    min-height: 20px;
    max-height: 20px;
    display: block;
}

.fiz_authid
{
    width:100%;
    box-sizing: border-box;
    font-size:14px;
    line-height: 14px;
    color: #444;
    text-align: center;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 15px 0px 5px 0px;
}

.payment_cancel
{
    width:100%;
    box-sizing: border-box;
    font-size:13px;
    line-height: 13px;
    text-align: center;
    font-weight: 500;
    margin: 10px 0px;
    background-color: #f1f2f3;
    margin-bottom: 0px;
    padding: 10px;
    border-top: solid 1px #ccc;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;    
}


.payment_cancel_button
{
    color: var(--premblue);
    opacity: 1;
    cursor:pointer;
}

.payment_cancel_button:hover
{
    opacity: 1;
    text-decoration: underline;
}

.payment_result_redir_text
{
    width:100%;
    box-sizing: border-box;
    font-size:13px;
    line-height: 16px;
    text-align: center;
    font-weight: normal;
    cursor:pointer;
    margin: 10px 0px;
    color: var(--premblue);
}


.txtBK_Osszeg_info
{
    width:100%;
    box-sizing: border-box;
    font-size:14px;
    line-height: 18px;
    text-align: left;
    font-weight: normal;
    color: var(--premblue);
}

.csodakartya_text1
{
    width:100%;
    box-sizing: border-box;
    font-size:14px;
    line-height: 18px;
    text-align: justify;
    font-weight: normal;
    color: var(--premblue);
}

.egyenlegfeltoltes_warning
{
    width:100%;
    box-sizing: border-box;
    font-size:14px;
    line-height: 18px;
    text-align: center;
    font-weight: 500;
    color: var(--premred);
    margin:10px 0px;
}









.spinner_cont
{
    width:100%;
    box-sizing: border-box;
    text-align: center;
}


.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 13px;
}
.lds-ellipsis div {
  position: absolute;
  top: 0
  px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: var(--premblue);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}




</style>